// src/components/ui/dashboard/hero-banner.tsx
"use client"

import { Button } from "@/components/ui/button"
import { Link } from "react-router";
import { useThemeStore } from "@/hooks/stores/themeStore"

interface HeroBannerProps {
  title?: string
  description?: string
  buttonText?: string
  onButtonClick?: () => void
  imageUrl?: string
  // Journey-aware props
  journeyTitle?: string
  journeySubtitle?: string
  journeyUrl?: string
  progressPercent?: number
}

export function HeroBanner({
  title = "Your Next Adventure!",
  description = "You're exploring the 'World of Biology'. Let's learn about amazing ecosystems!",
  buttonText = "Continue Learning",
  onButtonClick,
  imageUrl = "https://lh3.googleusercontent.com/aida-public/AB6AXuCiQBP1FiXjewjV4CMgiSh_WEABT0Gd6M_HkzJOr-4FnZL6xy8Qkf8L_34xPJSk_OriI-bdeq5nLSHwKjM6SqZyZ8YizYz-qmYgc7QRiRWF7MJ4PG7l6i4gj9ILlJBk4dIuAUDDfDwzZMs3v75PC4gkUpL1jRKTB-Apexu1hVP8MaAOybXxxxIuNlLnRzp4x8IK6lxLuz3Pu2E1KZQyh5xOL9l4iQKFxvA5RT9uKor5od3NDtB231ozdbjgEfLpJnu0HI--9Hu1Jco",
  journeyTitle,
  journeySubtitle,
  journeyUrl,
  progressPercent,
}: HeroBannerProps) {
  const currentTheme = useThemeStore((state) => state.getCurrentTheme());

  // Use journey data when provided
  const displayTitle = journeyTitle ?? title;
  const displayDescription = journeySubtitle ?? description;
  const displayTo = journeyUrl ?? "/learning-resources";

  return (
    <div
      className="p-8 rounded-2xl relative overflow-hidden flex items-center shadow-lg"
      style={{
        background: `linear-gradient(135deg, ${currentTheme.colors.primary}, ${currentTheme.colors.primary})`,
        border: `1px solid ${currentTheme.colors.border}`
      }}
    >
      <div className="relative z-10 text-white flex-1">
        <h3 className="text-2xl font-bold mb-2">{displayTitle}</h3>
        <p className="opacity-90 mb-4 max-w-sm">{displayDescription}</p>

        {/* Progress bar — shown when journey is in progress */}
        {progressPercent != null && (
          <div className="mb-4 max-w-xs">
            <div className="flex justify-between text-xs opacity-70 mb-1">
              <span>Path progress</span>
              <span>{progressPercent}%</span>
            </div>
            <div className="h-1.5 bg-white/20 rounded-full overflow-hidden">
              <div
                className="h-full bg-white/80 rounded-full transition-all duration-700"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>
        )}

        <Link to={displayTo}>
          <Button
            onClick={onButtonClick}
            className="font-semibold px-6 py-2 transition-all duration-200 hover:scale-105"
            style={{
              backgroundColor: 'white',
              color: currentTheme.colors.primary
            }}
          >
            {journeyTitle ? (progressPercent != null ? "Continue" : "Start Learning") : buttonText}
          </Button>
        </Link>
      </div>
      <img
        alt="Learning illustration"
        className="absolute right-0 bottom-0 w-64 h-auto opacity-80 z-0"
        src={imageUrl || "/placeholder.svg"}
      />
    </div>
  )
}